import { useMutation } from "react-query";
import inspectionService from "../services/inspectionService";

const useInspectionProgress = (onData) => {
  return useMutation(inspectionService.getInspectionProgress, {
    onSuccess: (data) => onData(data),
  });
};

const useSectionProgress = (onData) => {
  return useMutation(inspectionService.getSectionProgress, {
    onSuccess: (data) => onData(data),
  });
};

const useQuestionProgress = (onData) => {
  return useMutation(inspectionService.getQuestionProgress, {
    onSuccess: (data) => onData(data),
  });
};

const useInsertQuestionActionData = (onData) => {
  return useMutation(inspectionService.insertQuestionActionData, {
      onSuccess: (data) => {
          onData(data)
      },
  })
}

const useGetRemarkData = (onData) => {
  return useMutation(inspectionService.getRemarkData, {
      onSuccess: (data) => {
          onData(data)
      },
  })
}

const useExportInspectionReport = (onData) => {
  return useMutation(inspectionService.exportInspectionReport, {
      onSuccess: (data) => {
          onData(data);
      },
  });
};

const inspectionQueries = {
  useInspectionProgress,
  useSectionProgress,
  useQuestionProgress,
  useInsertQuestionActionData,
  useGetRemarkData,
  useExportInspectionReport
};

export default inspectionQueries;
